import React, { useState } from "react";
import './WebDesign.css';
import connectpeple from './assets/connectpeple.avif';
import socialstrategy from './assets/socialstrategy.avif';
import socialdevelopment from './assets/socialdevelopment.avif';

const SocialMedia = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Social Media Management</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Social Media Management</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Social Media Management – Connecting with Your Audience, Building Community</h2>
                            <p>Social media is more than just a marketing channel – it’s a powerful tool for engaging with your audience and building brand loyalty. Our Social Media Management services help you create compelling content, engage with your followers, and grow your presence across platforms like Facebook, Instagram, Twitter, and LinkedIn. We take the stress out of social media, ensuring that your brand is consistently represented and active online.</p>
                            <h3>Why Social Media Management Matters</h3>
                            <p>With millions of users active on social platforms daily, social media provides an excellent opportunity to connect with potential customers, strengthen brand awareness, and drive business growth. A strong, consistent presence is key to fostering meaningful relationships and increasing engagement.</p>
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={connectpeple} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 side-images py-5">
                            <img src={socialstrategy} alt="Mobile Optimization" className="mt-3" />
                        </div>
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>Our Social Media Strategy</h3>                                
                                <ol>
                                    <li><b>Content Creation & Curation:</b> Developing high-quality, engaging posts.</li>
                                    <li><b>Community Engagement:</b> Actively interacting with followers and customers.</li>
                                    <li><b>Performance Tracking & Analytics:</b> Measuring success and optimizing strategies.</li>
                                    <li><b>Paid Social Campaigns:</b> Using targeted ads to expand reach and boost engagement.</li>
                                </ol>
                            </div>
                        </div>                        
                    </div>

                    <div className="row">                        
                        <div className="col-md-6 py-5">
                            <div className="content-section text-column">
                                <h3>What We Offer</h3>                                
                                <ol>
                                    <li><b>Social Media Strategy Development:</b> Building a roadmap for success.</li>
                                    <li><b>Content Creation and Curation:</b> Delivering engaging and shareable content.</li>
                                    <li><b>Community Management and Audience Engagement:</b> Strengthening customer relationships.</li>
                                    <li><b>Analytics and Performance Reporting:</b> Monitoring and optimizing for better results.</li>                                    
                                </ol>
                            </div>
                        </div>
                        <div className="col-md-6 side-images py-5">
                            <img src={socialdevelopment} alt="Mobile Optimization" className="mt-3" />
                        </div>                       
                    </div>

                    <section className="hero-section text-column mb-5">
                        <p>Social media is a vital component of digital marketing. Let us help you build a strong, engaging social presence that drives results.</p>
                    </section>

                </div>
            </div>
        </>
    );
};

export default SocialMedia;
